import { z } from 'zod';

export const FEEDBACK_SURVEY_CAMPAIGN_KEY = 'user-feedback-survey-annual-v1';
export const FEEDBACK_SURVEY_OFFER_DURATION_HOURS = 12;
export const FEEDBACK_SURVEY_FIRST_YEAR_PRICE_USD = 54.9;
export const FEEDBACK_SURVEY_RENEWAL_PRICE_USD = 59.9;

export const MailerLiteSurveyCompletionWebhookSchema = z.object({
  type: z.literal('subscriber.added_to_group'),
  subscriber: z.object({
    id: z.string().regex(/^\d+$/),
    email: z.string().email(),
    status: z.string(),
    updated_at: z.string().datetime({ offset: true }),
  }).passthrough(),
  group: z.object({
    id: z.string().regex(/^\d+$/),
    name: z.string(),
  }).passthrough(),
  account_id: z.union([z.string(), z.number()]).optional(),
}).passthrough();

export const FeedbackSurveyWebhookResponseSchema = z.object({
  status: z.enum(['accepted', 'ignored']),
});

const FeedbackOfferPriceSchema = z.object({
  firstYearPriceUsd: z.literal(FEEDBACK_SURVEY_FIRST_YEAR_PRICE_USD),
  renewalPriceUsd: z.literal(FEEDBACK_SURVEY_RENEWAL_PRICE_USD),
});

export const FeedbackOfferCheckoutResponseSchema = z.discriminatedUnion('state', [
  FeedbackOfferPriceSchema.extend({
    state: z.literal('ready'),
    checkoutUrl: z.string().url(),
    expiresAt: z.string().datetime(),
  }),
  z.object({
    state: z.literal('not_completed'),
  }),
  z.object({
    state: z.literal('ineligible'),
  }),
  z.object({
    state: z.literal('expired'),
    expiresAt: z.string().datetime(),
  }),
  z.object({
    state: z.literal('complete'),
  }),
  z.object({
    state: z.literal('preparing'),
  }),
]);

export type MailerLiteSurveyCompletionWebhook = z.infer<
  typeof MailerLiteSurveyCompletionWebhookSchema
>;
export type FeedbackOfferCheckoutResponse = z.infer<
  typeof FeedbackOfferCheckoutResponseSchema
>;
